export const areasVerdes = [
  {
    id: "AV-001",
    nome: "Praça Universitária",
    tipo: "Praça",
    bairro: "Setor Leste Universitário",
    municipio: "Goiânia",
    uf: "GO",
    areaHa: 4.8,
    arvoresCadastradas: 187,
    arvoresRiscoCritico: 3,
    ultimaVistoria: "2026-06-15",
    status: "Ativa",
    co2eEstimado: 42.5,
    responsavel: "AMMA - Agência Municipal de Meio Ambiente",
    coordenadas: { lat: -16.6800, lng: -49.2563 },
    projetoVinculado: "Implantação do CTA — Goiânia Centro",
  },
  {
    id: "AV-002",
    nome: "Praça Cívica",
    tipo: "Praça",
    bairro: "Setor Central",
    municipio: "Goiânia",
    uf: "GO",
    areaHa: 8.2,
    arvoresCadastradas: 312,
    arvoresRiscoCritico: 5,
    ultimaVistoria: "2026-05-28",
    status: "Ativa",
    co2eEstimado: 78.3,
    responsavel: "AMMA - Agência Municipal de Meio Ambiente",
    coordenadas: { lat: -16.6788, lng: -49.2560 },
    projetoVinculado: "Implantação do CTA — Goiânia Centro",
  },
  {
    id: "AV-003",
    nome: "Parque Municipal Ambiental Norte",
    tipo: "Parque urbano",
    bairro: "Setor Norte Ferroviário",
    municipio: "Goiânia",
    uf: "GO",
    areaHa: 86.5,
    arvoresCadastradas: 1247,
    arvoresRiscoCritico: 12,
    ultimaVistoria: "2026-06-10",
    status: "Ativa",
    co2eEstimado: 320.8,
    responsavel: "Secretaria Municipal de Meio Ambiente",
    coordenadas: { lat: -16.6720, lng: -49.2500 },
    projetoVinculado: "Inventário Arbóreo — Parques e Bosques",
  },
  {
    id: "AV-004",
    nome: "Corredor Verde Sul",
    tipo: "Corredor verde",
    bairro: "Setor Sul",
    municipio: "Goiânia",
    uf: "GO",
    areaHa: 32.4,
    arvoresCadastradas: 623,
    arvoresRiscoCritico: 7,
    ultimaVistoria: "2026-05-20",
    status: "Em manutenção",
    co2eEstimado: 156.2,
    responsavel: "AMMA - Agência Municipal de Meio Ambiente",
    coordenadas: { lat: -16.6900, lng: -49.2620 },
    projetoVinculado: "Replantio Compensatório — Corredor Verde Sul",
  },
  {
    id: "AV-005",
    nome: "Jardim Botânico Municipal",
    tipo: "Jardim público",
    bairro: "Setor Pedro Ludovico",
    municipio: "Goiânia",
    uf: "GO",
    areaHa: 24.6,
    arvoresCadastradas: 456,
    arvoresRiscoCritico: 2,
    ultimaVistoria: "2026-06-18",
    status: "Ativa",
    co2eEstimado: 112.7,
    responsavel: "Secretaria Municipal de Meio Ambiente",
    coordenadas: { lat: -16.6850, lng: -49.2450 },
    projetoVinculado: "Inventário Arbóreo — Parques e Bosques",
  },
  {
    id: "AV-006",
    nome: "Bosque dos Buritis",
    tipo: "Bosque",
    bairro: "Setor Oeste",
    municipio: "Goiânia",
    uf: "GO",
    areaHa: 12.7,
    arvoresCadastradas: 289,
    arvoresRiscoCritico: 4,
    ultimaVistoria: "2026-04-30",
    status: "Pendente de vistoria",
    co2eEstimado: 68.4,
    responsavel: "AMMA - Agência Municipal de Meio Ambiente",
    coordenadas: { lat: -16.6805, lng: -49.2640 },
    projetoVinculado: "Revisão de Árvores Críticas",
  },
  {
    id: "AV-007",
    nome: "Praça do Sol",
    tipo: "Praça",
    bairro: "Setor Bueno",
    municipio: "Goiânia",
    uf: "GO",
    areaHa: 3.2,
    arvoresCadastradas: 94,
    arvoresRiscoCritico: 1,
    ultimaVistoria: "2026-06-01",
    status: "Ativa",
    co2eEstimado: 21.3,
    responsavel: "AMMA - Agência Municipal de Meio Ambiente",
    coordenadas: { lat: -16.6920, lng: -49.2700 },
    projetoVinculado: "Implantação do CTA — Goiânia Centro",
  },
  {
    id: "AV-008",
    nome: "Canteiro Central — Av. 85",
    tipo: "Canteiro central",
    bairro: "Setor Marista",
    municipio: "Goiânia",
    uf: "GO",
    areaHa: 6.8,
    arvoresCadastradas: 156,
    arvoresRiscoCritico: 8,
    ultimaVistoria: "2026-06-05",
    status: "Ativa",
    co2eEstimado: 35.9,
    responsavel: "AMMA - Agência Municipal de Meio Ambiente",
    coordenadas: { lat: -16.6880, lng: -49.2680 },
    projetoVinculado: "Implantação do CTA — Goiânia Centro",
  },
  {
    id: "AV-009",
    nome: "Área de Lazer Setor Jaó",
    tipo: "Área de lazer",
    bairro: "Setor Jaó",
    municipio: "Goiânia",
    uf: "GO",
    areaHa: 5.4,
    arvoresCadastradas: 112,
    arvoresRiscoCritico: 2,
    ultimaVistoria: "2026-05-15",
    status: "Ativa",
    co2eEstimado: 27.8,
    responsavel: "Secretaria Municipal de Esportes",
    coordenadas: { lat: -16.6700, lng: -49.2400 },
    projetoVinculado: null,
  },
  {
    id: "AV-010",
    nome: "Rotatória T-63 com T-9",
    tipo: "Rotatória",
    bairro: "Setor Bueno",
    municipio: "Goiânia",
    uf: "GO",
    areaHa: 0.8,
    arvoresCadastradas: 28,
    arvoresRiscoCritico: 0,
    ultimaVistoria: "2026-06-20",
    status: "Ativa",
    co2eEstimado: 6.4,
    responsavel: "AMMA - Agência Municipal de Meio Ambiente",
    coordenadas: { lat: -16.6940, lng: -49.2720 },
    projetoVinculado: "Implantação do CTA — Goiânia Centro",
  },
];

export const unidadesConservacao = [
  {
    id: "UC-001",
    nome: "Parque Natural Municipal do Cerrado",
    categoria: "Parque Natural Municipal",
    grupo: "Proteção Integral",
    municipio: "Goiânia",
    uf: "GO",
    areaHa: 340.5,
    instrumentoLegal: "Decreto Municipal nº 8.742/2012",
    temPlanoManejo: true,
    dataPlanoManejo: "2015-03-10",
    arvoresCadastradas: 2340,
    areasDegradadas: 18.5,
    co2eEstimado: 842.3,
    statusGestao: "Com plano de manejo",
    orgaoGestor: "Secretaria Municipal de Meio Ambiente",
    coordenadas: { lat: -16.6600, lng: -49.2800 },
    projetoVinculado: "Inventário Arbóreo — Parques e Bosques",
  },
  {
    id: "UC-002",
    nome: "APA do Córrego Samambaia",
    categoria: "APA",
    grupo: "Uso Sustentável",
    municipio: "Goiânia",
    uf: "GO",
    areaHa: 520.8,
    instrumentoLegal: "Lei Municipal nº 9.321/2015",
    temPlanoManejo: true,
    dataPlanoManejo: "2018-08-22",
    arvoresCadastradas: 1820,
    areasDegradadas: 42.3,
    co2eEstimado: 678.5,
    statusGestao: "Ativa",
    orgaoGestor: "AMMA - Agência Municipal de Meio Ambiente",
    coordenadas: { lat: -16.6750, lng: -49.2900 },
    projetoVinculado: "Monitoramento de UCs — Ciclo 2026",
  },
  {
    id: "UC-003",
    nome: "Reserva Ecológica do Cerrado",
    categoria: "RPPN",
    grupo: "Proteção Integral",
    municipio: "Goiânia",
    uf: "GO",
    areaHa: 185.2,
    instrumentoLegal: "Portaria ICMBio nº 456/2019",
    temPlanoManejo: true,
    dataPlanoManejo: "2020-11-15",
    arvoresCadastradas: 980,
    areasDegradadas: 8.2,
    co2eEstimado: 356.7,
    statusGestao: "Ativa",
    orgaoGestor: "ICMBio - Instituto Chico Mendes",
    coordenadas: { lat: -16.6550, lng: -49.3000 },
    projetoVinculado: "Monitoramento de UCs — Ciclo 2026",
  },
  {
    id: "UC-004",
    nome: "Bosque Municipal Dom Fernando",
    categoria: "Bosque Municipal",
    grupo: "Área verde municipal não enquadrada",
    municipio: "Goiânia",
    uf: "GO",
    areaHa: 28.4,
    instrumentoLegal: "Decreto Municipal nº 5.234/2005",
    temPlanoManejo: false,
    dataPlanoManejo: null,
    arvoresCadastradas: 512,
    areasDegradadas: 3.1,
    co2eEstimado: 124.8,
    statusGestao: "Sem plano de manejo",
    orgaoGestor: "AMMA - Agência Municipal de Meio Ambiente",
    coordenadas: { lat: -16.6820, lng: -49.2550 },
    projetoVinculado: null,
  },
  {
    id: "UC-005",
    nome: "Monumento Natural Pedra do Cedro",
    categoria: "Monumento Natural",
    grupo: "Proteção Integral",
    municipio: "Goiânia",
    uf: "GO",
    areaHa: 48.6,
    instrumentoLegal: "Lei Municipal nº 10.458/2018",
    temPlanoManejo: false,
    dataPlanoManejo: null,
    arvoresCadastradas: 345,
    areasDegradadas: 5.7,
    co2eEstimado: 87.2,
    statusGestao: "Em implantação",
    orgaoGestor: "Secretaria Municipal de Meio Ambiente",
    coordenadas: { lat: -16.6700, lng: -49.2450 },
    projetoVinculado: "Monitoramento de UCs — Ciclo 2026",
  },
];

export const appsUrbanas = [
  {
    id: "APP-001",
    nome: "APP Córrego Botafogo",
    tipo: "Área de Preservação Permanente",
    bairro: "Setor Leste Vila Nova",
    municipio: "Goiânia",
    uf: "GO",
    areaHa: 45.2,
    arvoresCadastradas: 420,
    arvoresRiscoCritico: 6,
    ultimaVistoria: "2026-06-12",
    status: "Ativa",
    co2eEstimado: 98.5,
    responsavel: "AMMA - Agência Municipal de Meio Ambiente",
    coordenadas: { lat: -16.6680, lng: -49.2350 },
    projetoVinculado: "Recuperação de APPs Urbanas",
  },
  {
    id: "APP-002",
    nome: "APP Ribeirão Anicuns",
    tipo: "Área de Preservação Permanente",
    bairro: "Setor Oeste",
    municipio: "Goiânia",
    uf: "GO",
    areaHa: 78.3,
    arvoresCadastradas: 680,
    arvoresRiscoCritico: 14,
    ultimaVistoria: "2026-05-25",
    status: "Crítica",
    co2eEstimado: 145.2,
    responsavel: "AMMA - Agência Municipal de Meio Ambiente",
    coordenadas: { lat: -16.6900, lng: -49.2800 },
    projetoVinculado: "Recuperação de APPs Urbanas",
  },
  {
    id: "APP-003",
    nome: "APP Córrego das Lages",
    tipo: "Área de Preservação Permanente",
    bairro: "Setor Norte Ferroviário",
    municipio: "Goiânia",
    uf: "GO",
    areaHa: 32.1,
    arvoresCadastradas: 215,
    arvoresRiscoCritico: 3,
    ultimaVistoria: "2026-06-08",
    status: "Ativa",
    co2eEstimado: 52.3,
    responsavel: "Secretaria Municipal de Meio Ambiente",
    coordenadas: { lat: -16.6600, lng: -49.2580 },
    projetoVinculado: "Recuperação de APPs Urbanas",
  },
  {
    id: "APP-004",
    nome: "APP Córrego Buriti",
    tipo: "Área de Preservação Permanente",
    bairro: "Setor Sul",
    municipio: "Goiânia",
    uf: "GO",
    areaHa: 28.7,
    arvoresCadastradas: 178,
    arvoresRiscoCritico: 2,
    ultimaVistoria: "2026-04-18",
    status: "Pendente de vistoria",
    co2eEstimado: 38.7,
    responsavel: "AMMA - Agência Municipal de Meio Ambiente",
    coordenadas: { lat: -16.6980, lng: -49.2650 },
    projetoVinculado: null,
  },
];

export const areasRecuperacao = [
  {
    id: "REC-001",
    nome: "Área de Recuperação — Antigo Lixão",
    tipo: "Área de recuperação",
    bairro: "Setor Perim",
    municipio: "Goiânia",
    uf: "GO",
    areaHa: 42.8,
    arvoresCadastradas: 320,
    arvoresRiscoCritico: 5,
    ultimaVistoria: "2026-06-05",
    status: "Em recuperação",
    co2eEstimado: 24.5,
    responsavel: "Secretaria Municipal de Meio Ambiente",
    coordenadas: { lat: -16.6650, lng: -49.3100 },
    projetoVinculado: "Recuperação de Áreas Degradadas — Fase 2",
  },
  {
    id: "REC-002",
    nome: "Área de Compensação — Marginal Botafogo",
    tipo: "Área de compensação",
    bairro: "Setor Leste Vila Nova",
    municipio: "Goiânia",
    uf: "GO",
    areaHa: 18.6,
    arvoresCadastradas: 245,
    arvoresRiscoCritico: 1,
    ultimaVistoria: "2026-05-30",
    status: "Em recuperação",
    co2eEstimado: 32.8,
    responsavel: "AMMA - Agência Municipal de Meio Ambiente",
    coordenadas: { lat: -16.6700, lng: -49.2300 },
    projetoVinculado: "Replantio Compensatório — Corredor Verde Sul",
  },
  {
    id: "REC-003",
    nome: "Replantio Compensatório — Setor Norte",
    tipo: "Área de replantio",
    bairro: "Setor Norte Ferroviário",
    municipio: "Goiânia",
    uf: "GO",
    areaHa: 12.4,
    arvoresCadastradas: 186,
    arvoresRiscoCritico: 0,
    ultimaVistoria: "2026-06-15",
    status: "Ativa",
    co2eEstimado: 18.2,
    responsavel: "Concessionária de Energia — Compensação",
    coordenadas: { lat: -16.6580, lng: -49.2520 },
    projetoVinculado: "Recuperação de Áreas Degradadas — Fase 2",
  },
  {
    id: "REC-004",
    nome: "Recuperação de Nascente — Córrego Areião",
    tipo: "Área de recuperação",
    bairro: "Setor Marista",
    municipio: "Goiânia",
    uf: "GO",
    areaHa: 8.2,
    arvoresCadastradas: 92,
    arvoresRiscoCritico: 2,
    ultimaVistoria: "2026-04-22",
    status: "Em recuperação",
    co2eEstimado: 14.6,
    responsavel: "Secretaria Municipal de Meio Ambiente",
    coordenadas: { lat: -16.6850, lng: -49.2750 },
    projetoVinculado: null,
  },
];

export const tiposAreaVerde = [
  "Praça",
  "Parque urbano",
  "Canteiro central",
  "Rotatória",
  "Bosque",
  "Jardim público",
  "Área institucional arborizada",
  "Corredor verde",
  "Área de lazer",
  "Área de compensação",
  "Área de replantio",
  "Área de recuperação",
];

export const statusArea = [
  "Ativa",
  "Em implantação",
  "Em manutenção",
  "Em recuperação",
  "Pendente de vistoria",
  "Crítica",
  "Inativa",
];

export const gruposUC = [
  "Proteção Integral",
  "Uso Sustentável",
  "Área verde municipal não enquadrada",
  "Área de interesse ambiental municipal",
];

export const categoriasUC = [
  "Parque Natural Municipal",
  "APA",
  "ARIE",
  "RPPN",
  "Monumento Natural",
  "Refúgio de Vida Silvestre",
  "Bosque Municipal",
  "Corredor Ecológico",
];

export const statusGestaoUC = [
  "Planejada",
  "Criada",
  "Em implantação",
  "Ativa",
  "Sem plano de manejo",
  "Com plano de manejo",
  "Em revisão",
  "Irregular",
  "Inativa",
];

export const resumoAmbiental = {
  areasVerdesCadastradas: 64,
  ucsCadastradas: 9,
  appsUrbanas: 18,
  areasRecuperacao: 12,
  areaTotalMapeada: 1842,
  arvoresDentroAreasAmbientais: 8426,
  riscoCriticoAreasAmbientais: 43,
  co2eEstimadoPreliminar: 3780,
};

export const documentosUC = [
  {
    id: "DOC-UC-001",
    tipo: "Decreto/Lei de Criação",
    numero: "8.742/2012",
    titulo: "Decreto de Criação do Parque Natural Municipal do Cerrado",
    data: "2012-06-15",
    emissor: "Prefeitura Municipal de Goiânia",
    status: "Vigente",
    arquivo: "decreto-8742-2012.pdf",
  },
  {
    id: "DOC-UC-002",
    tipo: "Plano de Manejo",
    numero: "PM-001/2015",
    titulo: "Plano de Manejo — Parque Natural Municipal do Cerrado",
    data: "2015-03-10",
    emissor: "Secretaria Municipal de Meio Ambiente",
    status: "Aprovado",
    arquivo: "plano-manejo-cerrado-2015.pdf",
  },
  {
    id: "DOC-UC-003",
    tipo: "Memorial Descritivo",
    numero: "MD-045/2012",
    titulo: "Memorial Descritivo da Poligonal",
    data: "2012-08-20",
    emissor: "Instituto Municipal de Planejamento",
    status: "Arquivado",
    arquivo: "memorial-descritivo-cerrado.pdf",
  },
  {
    id: "DOC-UC-004",
    tipo: "Relatório de Vistoria",
    numero: "RV-2026-012",
    titulo: "Relatório de Vistoria Técnica — Limites e Zona de Amortecimento",
    data: "2026-04-18",
    emissor: "AMMA",
    status: "Aprovado",
    arquivo: "relatorio-vistoria-2026.pdf",
  },
  {
    id: "DOC-UC-005",
    tipo: "Relatório Ambiental",
    numero: "RA-2025-008",
    titulo: "Relatório de Monitoramento da Fauna e Flora",
    data: "2025-12-05",
    emissor: "Consultoria Ambiental Cerrado Vivo",
    status: "Em revisão",
    arquivo: "relatorio-fauna-flora-2025.pdf",
  },
];

export const arvoresAreaVerde = [
  {
    codigoCTA: "CTA-GO-5208707-000423",
    especie: "Ipê-amarelo",
    nomeCientifico: "Handroanthus albus",
    estadoFitossanitario: "Bom",
    risco: "Baixo",
    recomendacao: "Monitorar",
    ultimaVistoria: "2026-06-10",
    dap: 28,
    altura: 7.2,
  },
  {
    codigoCTA: "CTA-GO-5208707-000891",
    especie: "Sibipiruna",
    nomeCientifico: "Caesalpinia peltophoroides",
    estadoFitossanitario: "Bom",
    risco: "Médio",
    recomendacao: "Poda de manutenção",
    ultimaVistoria: "2026-05-22",
    dap: 45,
    altura: 10.8,
  },
  {
    codigoCTA: "CTA-GO-5208707-000156",
    especie: "Ficus benjamina",
    nomeCientifico: "Ficus benjamina",
    estadoFitossanitario: "Regular",
    risco: "Alto",
    recomendacao: "Poda de redução e avaliação radicular",
    ultimaVistoria: "2026-06-01",
    dap: 68,
    altura: 14.5,
  },
  {
    codigoCTA: "CTA-GO-5208707-000742",
    especie: "Jacarandá-mimoso",
    nomeCientifico: "Jacaranda mimosifolia",
    estadoFitossanitario: "Bom",
    risco: "Baixo",
    recomendacao: "Monitorar",
    ultimaVistoria: "2026-06-12",
    dap: 22,
    altura: 6.5,
  },
  {
    codigoCTA: "CTA-GO-5208707-000983",
    especie: "Tipuana",
    nomeCientifico: "Tipuana tipu",
    estadoFitossanitario: "Ruim",
    risco: "Crítico",
    recomendacao: "Supressão — risco de queda iminente",
    ultimaVistoria: "2026-06-08",
    dap: 82,
    altura: 16.2,
  },
  {
    codigoCTA: "CTA-GO-5208707-000214",
    especie: "Oiti",
    nomeCientifico: "Licania tomentosa",
    estadoFitossanitario: "Bom",
    risco: "Baixo",
    recomendacao: "Monitorar",
    ultimaVistoria: "2026-05-30",
    dap: 35,
    altura: 9.1,
  },
  {
    codigoCTA: "CTA-GO-5208707-000567",
    especie: "Aroeira-salsa",
    nomeCientifico: "Schinus molle",
    estadoFitossanitario: "Regular",
    risco: "Médio",
    recomendacao: "Tratamento fitossanitário — fungos",
    ultimaVistoria: "2026-04-15",
    dap: 18,
    altura: 5.8,
  },
  {
    codigoCTA: "CTA-GO-5208707-000345",
    especie: "Flamboyant",
    nomeCientifico: "Delonix regia",
    estadoFitossanitario: "Bom",
    risco: "Baixo",
    recomendacao: "Poda de manutenção leve",
    ultimaVistoria: "2026-06-05",
    dap: 42,
    altura: 11.3,
  },
];

export const carbonoEstimativas = [
  {
    areaId: "AV-003",
    carbonoEstimado: 320.8,
    co2eEstimado: 842.3,
    arvoresConsideradas: 1247,
    metodologia: "Modelo alométrico — equação de Chave (2005) ajustada para Cerrado",
    nivelConfianca: "Médio (±18%)",
    ultimaAtualizacao: "2026-06-10",
  },
  {
    areaId: "UC-001",
    carbonoEstimado: 320.8,
    co2eEstimado: 842.3,
    arvoresConsideradas: 2340,
    metodologia: "Modelo alométrico — equação de Chave (2005) ajustada para Cerrado",
    nivelConfianca: "Médio (±18%)",
    ultimaAtualizacao: "2026-06-15",
  },
];

export const historicoUC = [
  {
    id: "HIST-001",
    data: "2012-06-15",
    tipo: "Criação",
    descricao: "Unidade de Conservação criada pelo Decreto Municipal nº 8.742/2012",
    responsavel: "Prefeitura Municipal de Goiânia",
    icone: "ri-file-text-line",
    cor: "bg-primary-500",
  },
  {
    id: "HIST-002",
    data: "2015-03-10",
    tipo: "Plano de Manejo",
    descricao: "Aprovação do Plano de Manejo da UC com zoneamento e programas de gestão",
    responsavel: "Secretaria Municipal de Meio Ambiente",
    icone: "ri-survey-line",
    cor: "bg-accent-500",
  },
  {
    id: "HIST-003",
    data: "2024-08-20",
    tipo: "Inventário Arbóreo",
    descricao: "Início do inventário florestal dentro dos limites da UC — Projeto 'Inventário Arbóreo — Parques e Bosques'",
    responsavel: "Equipe Técnica FloraIQ",
    icone: "ri-plant-line",
    cor: "bg-primary-500",
  },
  {
    id: "HIST-004",
    data: "2025-06-10",
    tipo: "Vistoria Técnica",
    descricao: "Vistoria completa com avaliação de fitossanidade, risco, espécies exóticas invasoras e áreas degradadas",
    responsavel: "Dr. Roberto Almeida — Analista Ambiental",
    icone: "ri-search-eye-line",
    cor: "bg-accent-500",
  },
  {
    id: "HIST-005",
    data: "2025-12-05",
    tipo: "Relatório Ambiental",
    descricao: "Relatório de monitoramento da fauna e flora — identificadas 42 espécies arbóreas nativas e 12 espécies de aves",
    responsavel: "Consultoria Ambiental Cerrado Vivo",
    icone: "ri-file-chart-line",
    cor: "bg-caution-500",
  },
  {
    id: "HIST-006",
    data: "2026-04-18",
    tipo: "Vistoria",
    descricao: "Vistoria de limites e zona de amortecimento — identificadas 18,5 ha de áreas degradadas necessitando recuperação",
    responsavel: "AMMA — Fiscalização Ambiental",
    icone: "ri-search-eye-line",
    cor: "bg-accent-500",
  },
  {
    id: "HIST-007",
    data: "2026-06-15",
    tipo: "Atualização Cadastral",
    descricao: "Atualização dos dados cadastrais da UC no sistema FloraIQ — 2.340 árvores georreferenciadas",
    responsavel: "Analista GIS — FloraIQ",
    icone: "ri-database-2-line",
    cor: "bg-primary-500",
  },
];